<template>
    <div>   
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            :edicao="!filtros.id_centro_custo"
                            v-model="filtros.id_unidade_operacao" />
                    </div>

                    <div class="col col-12 col-md-3" v-if="filtros.tipo_mov != 'T'">
                        <az-input
                            icon="fas fa-funnel-dollar fa-fw"
                            type="select"
                            placeholder="Todos os Centros de Custo..."
                            :optionsList="lista_centro_custo"
                            optionsData="id_centro_custo"
                            :edicao="!!filtros.id_unidade_operacao"
                            v-model="filtros.id_centro_custo" />
                    </div>

                    <div class="col col-12 col-md-3" v-else>
                        <az-input
                            icon="fa-solid fa-arrow-right-to-city fa-fw"
                            placeholder="Local de Destino..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="filtros.id_estoque_local_destino" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter fa-fw"
                            placeholder="Todos os Tipos..."
                            optionsMode="json"
                            :optionsList="[
                                { id: 'C', search: 'Consumo' },
                                { id: 'D', search: 'Devolução' },
                                { id: 'T', search: 'Transferência' },
                                { id: 'A', search: 'Compra' },
                            ]" 
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.tipo_mov" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter fa-fw"
                            placeholder="Classificação..."
                            optionsMode="json"
                            :optionsList="item_classes" 
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.classe">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                                        <i class="fa-solid fa-filter"></i>
                                        <span class="badge badge-primary ml-1" v-if="lista_add_filtros && lista_add_filtros.length">
                                            {{ lista_add_filtros.length }}
                                        </span>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter fa-fw"
                            placeholder="Todos os Status..."
                            optionsMode="json"
                            :optionsList="[
                                { id: 'A', search: 'Abertos' },
                                { id: 'X', search: 'Atendidos' },
                                { id: 'P', search: 'Pend. Autoriz.' },
                                { id: 'C', search: 'Cancelados' },
                            ]" 
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.status" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtros.paciente" 
                            :optimized_ac="true">
                        </az-input>
                    </div>


                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-warehouse fa-fw"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="filtros.id_estoque_local" />
                    </div>

                </div>

                <div class="form-row mt-2">

                    <div class="col col-12 col-md-6">
                        <az-input
                            icon="fa fa-search fa-fw"
                            v-model="filtros.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" @click="filtros.sel_aplic = !filtros.sel_aplic" v-if="atend_por_hr_aplic"
                                        data-toggle="tooltip" data-placement="top" title="Horário de Aplicação da Prescrição">
                                        <i class="fa-solid fa-alarm-plus"></i>
                                    </button>
                                    <button class="btn btn-outline-success" :disabled="!filtros.id_estoque_local" type="button" @click="incluir()"
                                        data-toggle="tooltip" data-placement="top" title="Consumo">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-primary" :disabled="!filtros.id_estoque_local" type="button" @click="devolver()"
                                        data-toggle="tooltip" data-placement="top" title="Devolução">
                                        <i class="fas fa-undo-alt"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary" :disabled="!filtros.id_estoque_local" type="button" @click="transferir()"
                                        data-toggle="tooltip" data-placement="top" title="Transferência">
                                        <i class="fas fa-exchange-alt"></i>
                                    </button>

                                    <print-export printid="lista-atend" pagina="suprimentos-atendimento" :parms="parms_relatorios" />
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'T', search: 'Todas' },
                                { id: 'S', search: 'Saldo' }, 
                                { id: 'N', search: 'Falta' }, 
                            ]"
                            :edicao="filtros.id_estoque_local > 0"
                            v-model="filtros.com_saldo"
                            @input="load(true)" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'L', search: 'Lista' },
                                { id: 'C', search: 'Consolidado' }, 
                            ]"
                            v-model="view"
                            @input="load(true)" />
                    </div>

                </div>

                <div class="form-row mt-2" v-if="filtros.sel_aplic">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-solid fa-alarm-plus fa-fw"
                            sizing="sm"
                            type="date"
                            v-model="filtros.dt_aplic">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="[
                                { id: '0', search: 'Todos' },
                                { id: '2', search: '2h' },
                                { id: 'F', search: 'Faixa' }, 
                            ]" 
                            optionsData="id" 
                            v-model="filtros.tipo_aplic"
                            @click="refresh_aplic()">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-1">
                        <az-input
                            sizing="sm"
                            type="time"
                            :edicao="filtros.tipo_aplic == 'F'"
                            v-model="filtros.hr_aplic_ini" />
                    </div>

                    <div class="col col-12 col-md-1">
                        <az-input
                            sizing="sm"
                            type="time"
                            :edicao="filtros.tipo_aplic == 'F'"
                            v-model="filtros.hr_aplic_fim" />
                    </div>

                    <div class="col col-12 col-md-1 d-flex flex-column" v-for="(horario, ihx) in lista_horarios" :key="ihx">
                        <button type="button" class="btn btn-sm" :class="(horario && ( filtros.hr_aplic_ini == horario.slice(-5) && filtros.hr_aplic_fim == horario.slice(-5) ) ) ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="selec_horario(horario)">{{ horario.slice(-5) }}</button>
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista || !lista.length" icon="fas fa-inbox" msg="Nenhuma solicitação identificada." />
        
        <div v-else id="lista-atend">

            <!-- Lista Consolidada -->

            <div v-if="view == 'C'">
                <div v-if="lista_classes && lista_classes.length">
                    <table class="table table-sm border-0 mb-1 table-responsive">
                        <tr>
                            <td class="text-nowrap">
                                <a href="#" @click.prevent="selecionar_classe(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                    <span class="badge badge-success mr-1" >
                                        {{ classe }}
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="text-right">
                    <a href="#" @click.prevent="apenas_gaps = !apenas_gaps" class="card-link" v-if="filtros_busca && filtros_busca.id_estoque_local">
                        <i class="fa-solid fa-cart-shopping fa-fw" v-if="!apenas_gaps"></i>
                        <i class="fa-solid fa-list fa-fw" v-else></i>
                    </a>

                    <a href="#" @click.prevent="detalhado = !detalhado" class="card-link ml-2">
                        <i class="fa-solid fa-minimize fa-fw" v-if="detalhado"></i>
                        <i class="fa-solid fa-maximize fa-fw" v-else></i>
                    </a>
                </div>

                <table class="table table-hover table-responsive-md cabecalho-fixo bg-white" :class="detalhado ? '' : 'table-sm'">
                    <thead>
                        <tr>
                            <td v-if="apenas_gaps"></td>
                            <th>Id</th>
                            <th>Descrição</th>
                            <th class="text-right">Solics</th>
                            <th class="text-right">Solicitado</th>
                            <th class="text-right">Baixado</th>
                            <th class="text-right">Pendente</th>
                            <template v-if="filtros_busca && filtros_busca.id_estoque_local">
                                <th class="text-right">Saldo</th>
                                <th class="text-right">CMM</th>
                                <th class="text-right">Em Aquisição</th>
                                <th class="text-right">GAP</th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item_c, icx) in lista_consolidada" :key="icx" :class="( ( filtros_busca && filtros_busca.id_estoque_local ) && ( item_c.qtde_solic - item_c.qtde_baixado ) > item_c.saldo ) ? 'table-danger' : ''">
                            <td v-if="apenas_gaps">
                                <az-input
                                    type="checkbox"
                                    v-if="item_c.gap > 0" 
                                    v-model="item_c.selecionado" />

                                <!-- v-model="item_c.selecao.fl_ativo" -->
                            </td>
                            <td>
                                #{{ item_c.id }}
                            </td>
                            <td>
                                {{ item_c.descricao }}
                                <div v-if="detalhado">
                                    <span class="small text-muted mr-3">{{ item_c.unidade }}</span>
                                    <a href="#" @click.prevent="selecionar_classe(classe)" v-for="(classe, ilx) in item_c.classes" :key="ilx">
                                        <span class="badge badge-success mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </div>
                            </td>
                            <td class="text-right"><span v-if="item_c.lista_solics" :title="'Solics: ' + item_c.lista_solics.join(', ')">{{ item_c.solics }}</span></td>
                            <td class="text-right">{{ item_c.qtde_solic }}</td>
                            <td class="text-right">{{ item_c.qtde_baixado }}</td>
                            <td class="text-right">{{ item_c.qtde_solic - item_c.qtde_baixado }}</td>
                            <template v-if="filtros_busca && filtros_busca.id_estoque_local">
                                <td class="text-right">{{ item_c.saldo }}</td>
                                <td class="text-right"><span v-if="item_c.cmm">{{ item_c.cmm }}</span></td>
                                <td class="text-right">
                                    <a href="#" @click.prevent="ver_ocs(item_c)" class="card-link" v-if="item_c.compra" :title="'Aquisição: ' + item_c.compra.id_aqs">
                                        {{ item_c.compra.qtde }}
                                    </a>
                                </td>
                                <td class="text-right">{{ ( ( item_c.qtde_solic - item_c.qtde_baixado ) > item_c.saldo ) ? ( item_c.qtde_solic - item_c.qtde_baixado - item_c.saldo ) : 0 }}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>

                <button type="button" class="btn btn-success" @click="incluir_aquisicao()" v-if="filtros_busca && filtros_busca.id_estoque_local && apenas_gaps && lista_consolidada.length">
                    <i class="fas fa-search-dollar mr-2"></i>
                    Aquisição
                </button>

                <pre v-if="false">{{ aqss }}</pre>
            </div>

            <div v-else>

                <cabecalho-generico titulo="Atendimentos">
                    <div v-if="filtros_busca">
                        <div>{{ $util.filtro_2_periodo(filtros_busca) }}</div>
                        <div v-if="filtros.search">Pesquisa: {{ filtros.search }}</div>
                    </div>
                </cabecalho-generico>

                <div class="card carde mb-2 w3-animate-opacity" v-for="(solic, index) in lista" :key="index">
                    <div class="card-body py-1 px-2">
                        <div class="row">
                            <div class="col col-12 col-md-2">
                                <div class="d-flex flex-column justify-content-center">
                                    <span class="badge badge-info mb-1" v-if="solic.fl_solic_compra">
                                        Compra
                                    </span>
                                    
                                    <span class="badge badge-danger" v-if="!solic.fl_ativo">
                                        Cancelada
                                    </span>
                                    <button type="button" class="btn btn-warning btn-sm" @click="autorizar_solicitacao(solic)" v-else-if="solic.fl_pend_aut">
                                        Pendente Autorização
                                    </button>

                                    <template v-else-if="solic.fl_solic_compra">
                                        <div v-if="solic.id_aquisicao" class="small text-muted text-center">
                                            Aquisição #{{ solic.id_aquisicao }}
                                        </div>
                                    </template>

                                    <button type="button" class="btn btn-sm" 
                                        :disabled="!filtros_busca || !filtros_busca.id_estoque_local"
                                        :class="solic.fl_estorno ? 'btn-primary' : ( solic.fl_transfer ? 'btn-secondary' : 'btn-success' )" 
                                        @click="iniciar_atender(solic)" v-else-if="!solic.atendido">
                                        {{ solic.fl_estorno ? 'Receber' : ( solic.fl_transfer ? 'Transferir' : 'Atender' ) }}
                                        <span class="badge badge-dark ml-1" title="Parcial" v-if="solic.parcial">
                                            P
                                        </span>
                                    </button>
                                    <button type="button" class="btn btn-sm" 
                                        :disabled="!filtros_busca || !filtros_busca.id_estoque_local"
                                        :class="solic.fl_estorno ? 'btn-outline-primary' : ( solic.fl_transfer ? 'btn-outline-secondary' : 'btn-outline-success' )"  
                                        @click="iniciar_atender(solic)" 
                                        v-else>
                                        {{ solic.fl_estorno ? 'Recebido' : ( solic.fl_transfer ? 'Transferido' : 'Atendido' ) }}
                                    </button>
                                </div>
                                <div v-if="solic.contatos && solic.contatos.length" class="text-center d-flex flex-column mt-1">
                                    <span class="badge text-truncate" :class="'badge-' + solic.contatos[0].contato_status.st_color">
                                        {{ solic.contatos[0].contato_status.search }}
                                    </span>
                                </div>
                                <div v-if="solic.dt_aplic && solic.hr_aplic" class="text-center text-muted mt-1" title="Horário de Aplicação">
                                    <i class="fa-solid fa-alarm-plus mr-2"></i>
                                    {{ $util.getFormatDate(solic.dt_aplic, 'DD/MM') }}
                                    {{ solic.hr_aplic }}
                                </div>
                                <div v-else-if="solic.id_receita" class="text-center text-primary mt-1" :title="'Prescrição: #' + solic.id_receita">
                                    <i class="fa-solid fa-pills"></i>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4">
                                <div>
                                    <i class="fa fa-calendar-o mr-2" aria-hidden="true"></i>
                                    {{ $util.getFormatDate(solic.dt_solicitacao) }}
                                    {{ solic.dt_solicitacao.substr(11,5) }}
                                    <small class="text-muted ml-3">#{{ solic.id_estoque_solicitacao }}</small>
                                    <small class="text-muted ml-3">{{ solic.usuario.st_login }}</small>
                                </div>
                                <div v-if="solic.local" title="Local de Armazenagem de Fornecimento">
                                    <i class="fa-solid fa-arrow-right-from-bracket fa-fw mr-2"></i>
                                    {{ solic.local.search }}    
                                </div>
                                <div>
                                    <div v-if="solic.fl_transfer" title="Destino Transferência">
                                        <i class="fa-solid fa-arrow-right-to-bracket fa-fw mr-2"></i>
                                        <span v-if="solic.destino">
                                            {{ solic.destino.search }}
                                        </span>
                                    </div >
                                    <div v-else-if="solic.centro_custo" title="Unidade / Centro de Custo">
                                        <i class="fa fa-building-o fa-fw mr-2" aria-hidden="true"></i>
                                        {{ solic.centro_custo.search }}
                                    </div >
                                </div>
                                <div v-if="solic.apoiado" title="Apoiado">
                                    <i class="fa-solid fa-house-signal fa-fw mr-2"></i>
                                    {{ solic.apoiado.search }}
                                    <span v-if="solic.apoiado.st_sigla" class="badge badge-dark ml-2">
                                        {{ solic.apoiado.st_sigla }}
                                    </span>

                                    <div v-if="solic.apoiado_origem" title="Origem">
                                        <i class="fa-solid fa-location-dot fa-fw mr-2"></i>
                                        {{ solic.apoiado_origem.search }}
                                    </div>
                                </div>
                            </div>
                            <div class="col col-12 col-md-6 d-flex justify-content-between align-items-stretch">
                                <div>
                                    <div v-if="solic.fl_paciente && solic.marcacao">
                                        <i class="fa fa-user mr-2" aria-hidden="true"></i>
                                        <span class="small">
                                            {{ solic.marcacao.nome_paciente }}

                                            <span v-if="solic.marcacao.id_atendimento" class="ml-2">
                                                <a href="#" @click.prevent="abrir_atendimento(solic.marcacao.id_atendimento)" class="card-link">
                                                    #{{ solic.marcacao.id_atendimento }}
                                                </a>
                                            </span>

                                            <span v-else-if="solic.marcacao.id_marcacao" class="ml-2">
                                                <a href="#" @click.prevent="abrir_recepcao('M' + solic.marcacao.id_marcacao)" class="card-link">
                                                    M{{ solic.marcacao.id_marcacao }}
                                                </a>
                                            </span>

                                            <span v-if="solic.marcacao.plano && solic.marcacao.plano.operadora" class="ml-2 text-muted">
                                                {{ solic.marcacao.plano.operadora.search }}
                                            </span>
                                        </span>
                                    </div>
                                    <div v-if="solic.kits">
                                        <span class="badge badge-primary">
                                            {{ solic.kits }}
                                        </span>
                                    </div>
                                    <div>
                                        <span class="badge badge-secondary mr-2">{{ solic.items.length }}</span>
                                        <span v-if="solic.materiais">
                                            {{ solic.materiais.length > 150 ? solic.materiais.substr(0,150) + '...' : solic.materiais }}
                                        </span>
                                    </div>
                                    <div v-if="solic.st_observacao" class="small text-muted">
                                        {{ solic.st_observacao }}
                                    </div>
                                </div>
                                <div class="d-flex align-item-center">
                                    <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                        <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <template v-if="solic.fl_solic_compra && !solic.fl_pend_aut">
                                                <button class="dropdown-item" @click="ver_aquisicao(solic.id_aquisicao)" v-if="solic.id_aquisicao">
                                                    Processo de Aquisição #{{ solic.id_aquisicao }}
                                                </button>
                                                <button class="dropdown-item" @click="gerar_aquisicao(solic)" v-else>
                                                    Gerar Processo de Aquisição
                                                </button>
                                            </template>
                                            <button class="dropdown-item" @click="registrar_contatos(solic)">
                                                Ocorrências
                                            </button>
                                            <button class="dropdown-item" @click="imprimir_solicitacao(solic)">
                                                Imprimir
                                            </button>
                                            <button class="dropdown-item" @click="printEtiqueta(solic.marcacao)" v-if="solic.marcacao">
                                                Emitir Etiqueta Paciente
                                            </button>
                                            <button class="dropdown-item" @click="consultar_consumos(solic.marcacao.id_marcacao)" v-if="solic.marcacao">
                                                Consultar Consumos do Paciente
                                            </button>
                                            <template v-if="solic && solic.fl_ativo">
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item" @click="devolver_por_solic(solic)" v-if="solic.marcacao">
                                                    Devolução Consumo do Paciente
                                                </button>
                                                <button class="dropdown-item" @click="cancelar_solicitacao(solic)">
                                                    Cancelar Solicitação
                                                </button>
                                            </template>

                                            <template v-if="!solic.atendido && !solic.fl_estorno && !solic.fl_transfer && !solic.parcial">
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item" @click="$refs.sol_alt.alterar_local(solic)">
                                                    Alterar Local de Armazenagem
                                                </button>
                                                <button class="dropdown-item" @click="$refs.sol_alt.alterar_centro(solic)">
                                                    Alterar Centro de Custo
                                                </button>
                                                <button class="dropdown-item" @click="$refs.sol_alt.alterar_data(solic)">
                                                    Alterar Data
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <!-- Modal de Atendimento -->
        <div class="modal fade" id="estoqueAtenderModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ item.fl_estorno ? 'Receber Devolução' : ( item.fl_transfer ? 'Transferir' : 'Atender Solicitação' ) }} 
                            <span class="badge badge-secondary">#{{ item.id_estoque_solicitacao }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card mb-1">
                            <div class="card-body d-flex justify-content-between py-2">
                                <div>
                                    <div v-if="item.marcacao" title="Paciente" class="lead">
                                        <i class="fa-solid fa-user-injured fa-fw mr-2"></i>
                                        {{ item.marcacao.nome_paciente }}
                                    </div>
                                    <div v-if="item.marcacao && item.marcacao.id_atendimento" title="Atendimento">
                                        <i class="fa-solid fa-play fa-fw mr-2"></i>
                                        #{{ item.marcacao.id_atendimento }}
                                    </div>
                                    <div title="Data da Solicitação">
                                        <i class="fa fa-calendar-o fa-fw mr-2" aria-hidden="true"></i>
                                        {{ $util.getFormatDate(item.dt_solicitacao) }}
                                        {{ item.dt_solicitacao.substr(11,5) }}
                                    </div>
                                    <div>
                                        <i class="fa-solid fa-arrow-right-from-bracket fa-fw mr-2"></i>
                                        {{ item.local.search }}    
                                    </div>
                                    <div>
                                        <template v-if="item.fl_transfer">
                                            <i class="fa-solid fa-arrow-right-to-bracket fa-fw mr-2"></i>
                                            <span v-if="item.destino">
                                                {{ item.destino.search }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <i class="fa fa-building-o fa-fw mr-2" aria-hidden="true"></i>
                                            {{ item.centro_custo.search }}, 
                                            <small class="text-muted">{{ item.usuario.st_login }}</small>
                                        </template>
                                    </div>

                                    <div v-if="item.marcacao && item.marcacao.plano" title="Operadora / Plano">
                                        <i class="far fa-credit-card fa-fw mr-2"></i>
                                        {{ item.marcacao.plano.search }}
                                    </div>

                                    <div v-if="item.fl_pend_aut === false && item.id_usuario_aut && item.usuario_aut">
                                        <i class="fa-solid fa-circle-check fa-fw mr-2"></i>
                                        Autorizado por: {{ item.usuario_aut.st_login }}, em {{ $util.getFormatDate(item.dt_aut) }} {{ item.dt_aut.slice(11,16) }}
                                    </div>

                                    <div v-if="item.apoiado">
                                        <i class="fa-solid fa-house-signal fa-fw mr-2"></i>
                                        {{ item.apoiado.search }}
                                        <span v-if="item.apoiado.st_sigla" class="badge badge-dark ml-2">
                                            {{ item.apoiado.st_sigla }}
                                        </span>

                                        <div v-if="item.apoiado_origem" title="Origem">
                                            <i class="fa-solid fa-location-dot fa-fw mr-2"></i>
                                            {{ item.apoiado_origem.search }}
                                        </div>
                                    </div>
                                </div>

                                <div v-if="item.dt_aplic && item.hr_aplic">
                                    <i class="fa-solid fa-alarm-plus fa-fw mr-2"></i>
                                    <strong>
                                        {{ $util.getFormatDate(item.dt_aplic, 'DD/MM') }}
                                        {{ item.hr_aplic }}
                                    </strong>
                                </div>
                            </div>
                        </div>

                        <!-- Internação -->
                        <micro-view-internacao :internacao="item.marcacao.atendimento.internacao" v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.internacao" />

                        <!-- Sala de Procedimento -->
                        <div class="alert alert-info px-2 py-1 small mb-1" v-if="item && item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.local_momento">
                            <i class="fa-solid fa-street-view fa-fw mr-2"></i>
                            {{ item.marcacao.atendimento.local_momento.search }}
                        </div>

                        <!-- Alergias -->
                        <div class="alert alert-danger py-2 mb-1" v-if="item && item.marcacao && item.marcacao.paciente && item.marcacao.paciente.alergias && item.marcacao.paciente.alergias.length">
                            <div class="lead">Alergias:</div>
                            <div v-for="(alergia, iax) in item.marcacao.paciente.alergias" :key="iax">
                                <strong>{{ alergia.tipo.search }}</strong>
                                <template v-if="alergia.st_observacoes">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>{{ alergia.st_observacoes }}
                                </template>
                            </div>
                        </div>
                              
                        <div class="form-row mb-1" v-if="!item.atendido">
                            <div class="col col-12 col-md-6 d-flex flex-column">
                                <button type="button" class="btn btn-sm btn-outline-success" @click="indicar_atendimento(item)">{{ titulo_acao }} Todos</button>
                            </div>
                            <div class="col col-12 col-md-6 d-flex flex-column">
                                <button type="button" class="btn btn-sm btn-outline-danger" @click="indicar_atendimento(item, false)">Não {{ titulo_acao }} Todos</button>
                            </div>
                        </div>

                        <div class="mb-2" v-if="!item.atendido">
                            <selecao-material @selecionado="identificar_item" :id_estoque_local="item.id_estoque_local" :infoqt="true" />
                        </div>

                        <az-empty-state v-if="item.carregando" />

                        <table class="table table-responsive-md" v-else>
                            <thead>
                                <tr>
                                    <th>Descrição</th>
                                    <th>Saldo</th>
                                    <th>Lote</th>

                                    <template v-if="item.atendido">
                                        <th>Solicitado</th>
                                        <th>Atendido</th>
                                        <th>%</th>
                                        <th></th>
                                    </template>

                                    <template v-else>
                                        <th>Qtde</th>
                                        <th>Atender</th>
                                        <th></th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(material, imx) in tratar_ordem(item.items)">
                                    <tr :key="imx" :class="cor_linha(material) ? 'table-' + cor_linha(material) : ''" v-if="true">
                                        <td>
                                            <span>{{ material.item.search }}</span>    
                                            <span class="ml-1" v-if="material.fl_block_cobranca" title="Sem cobrança para esse item.">
                                                <i class="fa-brands fa-creative-commons-nc"></i>    
                                            </span>
                                            <span class="badge badge-secondary ml-1">#{{ material.id_estoque_item}}</span>
                                            <span v-if="material.item.mav" class="badge badge-danger ml-1" title="MAV: Medicamento de Alta Vigilância">MAV</span>

                                            <div v-if="material.st_observacao" class="small text-muted">{{ material.st_observacao }}</div>    
                                            <div v-if="material.receita_medicamento" class="small" title="Prescrição / Uso">
                                                <span class="text-primary mr-1" title="Prescrição">
                                                    <i class="fa-solid fa-pills"></i>
                                                </span>
                                                <span class="badge badge-danger mx-1" v-if="material.receita_medicamento.fl_suspenso">
                                                    Suspenso
                                                </span>
                                                <span class="text-muted" v-if="material.receita_medicamento.uso">
                                                    {{ material.receita_medicamento.uso.search }}
                                                    <span v-if="material.receita_medicamento.via">
                                                        | {{ material.receita_medicamento.via.search }}
                                                    </span>
                                                </span>
                                            </div>   
                                            
                                            <div v-if="exibir_local && material.item && material.item.limite && material.item.limite.st_local" class="small text-muted" title="Localização.">
                                                <i class="fa fa-map-o mr-1" aria-hidden="true"></i>
                                                {{ material.item.limite.st_local }}
                                            </div>

                                            <template v-if="material.list_subs">
                                                <div class="list-group small">
                                                    <button type="button" class="list-group-item list-group-item-action py-2" v-for="(sub, isx) in material.item.subs" :key="isx" @click="substituto(material, sub)">
                                                        {{ sub.por.search }}
                                                        <span class="badge badge-secondary">#{{ sub.por.id_estoque_item }}</span>
                                                    </button>
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="!material.fin">
                                                {{ qtde_lote(material) }}
                                                <a href="#" @click.prevent="ver_subs(material)" v-if="material.item && material.item.subs && material.item.subs.length" title="Substitutos">
                                                    <i class="fa-solid fa-star-half-stroke"></i>
                                                </a>
                                            </template>
                                        </td>
                                        <td style="max-width: 250px;">
                                            <div v-if="material.fin">
                                                {{ lista_lotes(material) }}
                                            </div>
                                            <div v-else-if="material.st_lote">
                                                <az-input
                                                    sizing="sm"
                                                    type="label"
                                                    :label="material.st_lote">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend" v-if="!material.outro_lote && ( !material.lotes || !material.lotes.length )">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="material.st_lote = null">
                                                                <i class="fa fa-times" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div v-else-if="material.lotes">
                                                <pre v-if="false">{{ material.lotes }}</pre>
                                                <div v-for="(lote_ident, ilx) in material.lotes" :key="ilx">
                                                    <small >
                                                        Lote: {{ lote_ident.lote.numero }}
                                                    </small>
                                                    <a href="#" @click.prevent="editar_lote_qt(lote_ident, material)" title="Quantidade.">
                                                        <span class="badge badge-secondary">{{ lote_ident.quantidade ? lote_ident.quantidade : 1 }}</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-else-if="material.item.fl_controla_lote && material.item.saldo_por_lote">
                                                <az-input
                                                    v-if="material.info_lote"
                                                    sizing="sm"
                                                    placeholder="Lote..."
                                                    ref="lote"
                                                    type="autocomplete" 
                                                    optionsMode="aql"
                                                    service="estoque_lotes.index"
                                                    :optionsParm="{ id_estoque_item: material.id_estoque_item, id_estoque_local: item.id_estoque_local }"
                                                    :optionsSync="true"
                                                    optionsData="st_lote"
                                                    v-model="material.st_lote" 
                                                    selecionado2="selecionar_lote()">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="!material.st_lote">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                                @click="toggle_buscar_lotes(material)">
                                                                <i class="fa-solid fa-pen"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>

                                                <az-input
                                                    v-else
                                                    type="select"
                                                    sizing="sm"
                                                    :optionsList="material.item.saldo_por_lote.map(lote => { 
                                                        return { 
                                                            id: lote.st_lote, 
                                                            search: $util.tratar_num_lote(lote.st_lote) 
                                                                + ( lote.validade ? ' (V: ' + $util.getFormatDate(lote.validade) + ')' : '' )
                                                                + ( lote.consig == 'S' ? ' (Consig) ' + ( ( lote.fornecedor && lote.fornecedor.search ) ? lote.fornecedor.search : '' ) : '' ), 
                                                        };
                                                    })"
                                                    optionsData="id"
                                                    v-model="material.st_lote">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="!material.st_lote">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" v-if="item.fl_estorno"
                                                                @click="toggle_buscar_lotes(material)">
                                                                <i class="fa-solid fa-pen"></i>
                                                            </button>
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                                @click="buscar_lotes(material.item)">
                                                                <i class="fa fa-search" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </td>

                                        <template v-if="item.atendido">

                                            <td class="text-nowrap">
                                                {{ material.in_quantidade }}
                                                <small class="text-muted ml-1">
                                                    {{ material.item.st_unidade_estoque }}
                                                </small>
                                            </td>

                                            <td>
                                                {{ material.baixado }}
                                            </td>

                                            <td>
                                                <span v-if="material.baixado > 0 && material.in_quantidade > 0">
                                                    {{ $util.formatMoeda( ( material.baixado / material.in_quantidade ) * 100, 1 ) }}%
                                                </span>

                                                <span v-else>
                                                    0%
                                                </span>
                                            </td>

                                            <td>
                                                <ul class="small">
                                                    <template v-for="(link, ilx) in material.links">
                                                        <li :key="ilx" v-if="link.movimentacao">
                                                            <strong>{{ link.movimentacao.in_quantidade }}</strong>, 
                                                            em {{ $util.getFormatDate(link.movimentacao.dt_movimentacao) }} {{ link.movimentacao.dt_movimentacao.slice(11,16) }},
                                                            por {{ link.movimentacao.usuario ? link.movimentacao.usuario.st_login : '?' }}
                                                        </li>
                                                    </template>
                                                </ul>
                                            </td>

                                        </template>

                                        <template v-else>

                                            <td class="text-nowrap">
                                                <template v-if="material.baixado">
                                                    {{ material.in_quantidade - material.baixado }}/{{ material.in_quantidade }}
                                                </template>
                                                <template v-else>
                                                    {{ material.in_quantidade }}
                                                </template>
                                                <small class="text-muted ml-1">
                                                    {{ material.item.st_unidade_estoque }}
                                                </small>
                                            </td>
                                            <td>
                                                <az-input
                                                    v-if="!material.fin"
                                                    sizing="sm"
                                                    type="number"
                                                    :placeholder="titulo_acao + '...'"
                                                    :validate="validate"
                                                    :edicao="!material.outro_lote && ( !material.lotes || !material.lotes.length )"
                                                    v-model="material.qtde_baixa">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                                @click="adicionar_lote(material)"
                                                                v-if="!material.outro_lote && material.st_lote && material.qtde_baixa > 0 && material.qtde_baixa < material.in_quantidade">
                                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </td>
                                            <td class="text-right text-nowrap">
                                                <template v-if="!material.outro_lote && !material.fin">
                                                    
                                                    <a href="#" @click.prevent="transformar(material)" class="card-link text-reset mr-0" v-if="material.item && material.item.apresentacoes && material.item.apresentacoes.length" title="Transformação de apresentação.">
                                                        <i class="fa-solid fa-circle-chevron-up fa-2x ml-2"></i>
                                                    </a>

                                                    <a href="#" @click.prevent="material.qtde_baixa = ( material.in_quantidade - ( material.baixado ? material.baixado : 0 ) ); material.fl_pendente = false" class="card-link text-reset mx-0" title="Atender">
                                                        <i class="fa fa-check-circle fa-2x ml-2" 
                                                            :class="( material.qtde_baixa == ( material.in_quantidade - ( material.baixado ? material.baixado : 0 ) ) )
                                                                ? 'text-success' 
                                                                : material.qtde_baixa ? 'text-warning' : 'text-dark'" aria-hidden="true"></i>
                                                    </a>
                                                    
                                                    <a href="#" @click.prevent="selecionar_nao_atender(material, imx)" class="card-link text-reset ml-0" title="Não Atender">
                                                        <i class="fa fa-times-circle fa-2x ml-2" 
                                                            :class="material.qtde_baixa === 0 ? 'text-danger' : 'text-dark'" aria-hidden="true"></i>
                                                    </a>

                                                    <template v-if="atend_parcial">

                                                        <a href="#" @click.prevent="material.fl_pendente = !material.fl_pendente;" class="card-link text-reset ml-0" title="Manter diferença pendente." 
                                                            v-if="atend_parcial && material.qtde_baixa < ( material.in_quantidade - ( material.baixado ? material.baixado : 0 ) )">
                                                            <i class="fa-solid fa-circle-pause fa-2x ml-2" :class="material.fl_pendente ? 'text-primary' : 'text-dark'" aria-hidden="true"></i>
                                                        </a>

                                                        <span v-else class="text-muted"> 
                                                            <i class="fa-solid fa-circle-pause fa-2x ml-2" aria-hidden="true"></i>
                                                        </span>

                                                    </template>

                                                </template>
                                            </td>

                                        </template>
                                    </tr>

                                    <tr v-if="material.item.exibir_lotes && !material.st_lote" :key="'l' + imx">
                                        <td colspan="6">
                                            <ul class="list-group" >
                                                <li class="list-group-item d-flex justify-content-between" v-for="(item_lote, ilx) in material.item.saldo_por_lote" :key="ilx">
                                                    <div>
                                                        <a href="#" @click.prevent="material.st_lote = item_lote.st_lote; material.item.exibir_lote = false;">
                                                            {{ $util.tratar_num_lote(item_lote.st_lote) }}
                                                        </a>
                                                        <span v-if="item_lote.fornecedor" class="ml-3 small text-muted">(Consig) {{ item_lote.fornecedor.search }}</span>
                                                    </div>
                                                    <div>
                                                        <span class="mr-2">{{ item_lote.qtd }}</span>
                                                        <i class="fas fa-boxes mr-5"></i>
                                                        
                                                        <span class="mr-2">{{ $util.getFormatDate(item_lote.validade) }}</span>
                                                        <i class="fas fa-hourglass-end"></i>
                                                    </div>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <!-- Campos Customizados -->
                        <div>
                            <div v-if="item.campos_customizados" class="row">
                                <div class="col col-12">
                                    <az-sub-title :title="item.campos_customizados.st_titulo" :big="true" />
                                    <formulario
                                        :gutters="true"
                                        :validate="validate"
                                        v-model="item.campos_customizados.js_campos"
                                        :saved="true"
                                        mode="fixed"
                                        :config="true" />
                                </div>
                            </div>
                        </div>

                        <!-- Prescrição -->

                        <div class="mt-3" v-if="item && item.id_receita && item.receita && item.receita.flat_items && item.receita.flat_items.length">
                            <a href="#" @click.prevent="detalhe_prescr = !detalhe_prescr" class="card-link">
                                <i class="fa fa-plus-square-o" aria-hidden="true" v-if="!detalhe_prescr"></i>
                                <i class="fa fa-minus-square-o" aria-hidden="true" v-else></i>
                                Detalhes Prescrição
                            </a>

                            <presc-suprimentos :receita="item.receita" v-if="detalhe_prescr" :data_aplic="item.dt_aplic" />

                            <br><br><br><br><br>
                        </div>

                        <!--
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between" v-for="(material, imx) in item.items" :key="imx"
                                :class="cor_linha(material) ? 'list-group-item-' + cor_linha(material) : ''">
                                <div>
                                    {{ material.item.search }}
                                    <div v-if="material.st_lote">
                                        <small>Lote: {{ material.st_lote }}</small>
                                    </div>
                                    <div v-else-if="material.lotes">
                                        <pre v-if="false">{{ material.lotes }}</pre>
                                        <div v-for="(lote_ident, ilx) in material.lotes" :key="ilx">
                                            <small >
                                                Lote: {{ lote_ident.lote.numero }}
                                            </small>
                                            <span class="badge badge-secondary">{{ lote_ident.quantidade ? lote_ident.quantidade : 1 }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="mr-3">
                                        {{ material.in_quantidade }}
                                        <small class="text-muted ml-1">
                                            {{ material.item.st_unidade_estoque }}
                                        </small>
                                    </div>
                                    <div>
                                        <az-input
                                            type="number"
                                            :placeholder="titulo_acao + '...'"
                                            :validate="validate"
                                            :edicao="!material.lotes || !material.lotes.length"
                                            v-model="material.qtde_baixa" />
                                    </div>
                                    <div>
                                        <a href="#" @click.prevent="material.qtde_baixa = material.in_quantidade" class="card-link text-reset mr-0">
                                            <i class="fa fa-check-circle fa-2x ml-2" 
                                                :class="material.qtde_baixa == material.in_quantidade 
                                                    ? 'text-success' 
                                                    : ( material.qtde_baixa ? 'text-warning' : 'text-dark' )" aria-hidden="true"></i>
                                        </a>
                                        
                                        <a href="#" @click.prevent="material.qtde_baixa = 0; material.lotes = []" class="card-link text-reset ml-0">
                                            <i class="fa fa-times-circle fa-2x ml-2" 
                                                :class="material.qtde_baixa === 0 ? 'text-danger' : 'text-dark'" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        -->
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div class="d-flex">
                            <template>
                                <az-input
                                    class="mr-2"
                                    type="checkbox-group"
                                    label="Ordem Alfabética"
                                    v-model="ordem_alfa" />
                            </template>
                            <template v-if="retroativo && !item.atendido">
                                <az-input
                                    class="mr-2"
                                    type="checkbox-group"
                                    label="Retroativo"
                                    v-model="item.retroativo" />

                                <az-input   
                                    class="mr-2"
                                    v-if="item.retroativo"
                                    type="datetime-local"
                                    required
                                    :validate="validate"
                                    v-model="item.dt_retroativo" />
                            </template>

                            <template v-if="!item.atendido">
                                <az-input
                                    class="mr-2"
                                    type="checkbox-group"
                                    label="Imprimir"
                                    v-model="impressao_solicitacao" />
                            </template>

                            <az-input
                                v-if="tem_localizacao"
                                class="mr-2"
                                type="checkbox-group"
                                label="Localização"
                                v-model="exibir_local" />
                            
                            <template v-if="!item.atendido">
                                <button type="button" class="btn btn-outline-secondary mb-1" @click="selecionar_primeiro_lote()">
                                    1o. Lote
                                </button>
                            </template>
                        </div>
                        <div>
                            <az-audit-log-button model="estoqueSolicitacao" :id="item.id_estoque_solicitacao" />
                            <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atender()" v-if="!item.atendido">Confirmar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <!-- Editar Quantidade -->

        <div class="modal fade" id="editarQtdeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_lote_qt">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Quantidade
                        </h5>
                        <button type="button" class="close" @click="fechar_modal('editarQtdeModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="edicao_lote_qt && edicao_lote_qt.lote">
                            Lote: {{ edicao_lote_qt.lote.numero }}
                        </div>
                        
                        <az-input 
                            type="number" 
                            label="Quantidade"
                            v-model="edicao_lote_qt.quantidade"  />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('editarQtdeModal')">Fechar</button>
                        <button type="button" class="btn btn-success" @click="atualizar_qt()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Outros Componentes -->

        <transforma-apresentacao ref="transform" @reabrir="reabrir" @refresh="load()" />

        <registrar-contatos 
                :lista_status="lista_status ? lista_status : []" 
                :extra_parms="{}"
                ref="regcontatos" 
                titulo="Solicitação"
                @refresh="load()">
                <template v-slot:info>
                    <template v-if="solic_contato">
                        Solicitação: #{{ solic_contato.id_estoque_solicitacao }}
                    </template>
                </template>
        </registrar-contatos>

        <gerar-aquisicao-lista ref="gerar_aq" />
        
        <!-- Emitir Etiqueta -->
        <emitir-etiqueta ref="etiqueta" />

        <!-- Ver OCs -->
        <ver-lista-ocs ref="ver_ocs" />

        <!-- Autorizar Solicitação -->
        <estoque-solicitacao-autorizar ref="aut_solic" @refresh="load()" />

        <!-- Consultar Consumos Pacientes -->
        <estoque-consultar-consumos-pacientes ref="consumos_pacientes" />

        <!-- Solicitação / Alteração -->
        <solicitacao-alteracao ref="sol_alt" @refresh="load()" />

        <!-- Filtros -->
        <crm-filtros ref="filtros" model_type="App\azure\estoqueItem" @refresh="atualizar_filtros"/>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import PrintExport from '../../shared/PrintExport.vue';
import TransformaApresentacao from './TransformaApresentacao.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import GerarAquisicaoLista from './GerarAquisicaoLista.vue';
import VerListaOcs from './VerListaOcs.vue';
import EstoqueSolicitacaoAutorizar from './EstoqueSolicitacaoAutorizar.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Formulario from '../consultorio/Formulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import EstoqueConsultarConsumosPacientes from './EstoqueConsultarConsumosPacientes.vue';
import SolicitacaoAlteracao from './SolicitacaoAlteracao.vue';
import PrescSuprimentos from '../../shared/PrescSuprimentos.vue';
import CrmFiltros from '../crm/CrmFiltros.vue';
import MicroViewInternacao from '../internacao/MicroViewInternacao.vue';

export default {
    data() { 
        return { 
            search: "",
            dados: null, 
            montando: true, 
            item: null, 
            validate: false, 
            canceltoken: null, 
            ordem_alfa: false,
            filtros: { 
                classe: "", 
                status: "A",
                id_estoque_local: "", 
                inicio: "",
                fim: "", 
                semana: "",
                mes: "",
                periodo: "s",
                referencia: "", 
                tipo_mov: "", 
                search: "", 
                id_unidade_operacao: "", 
                id_centro_custo: "", 
                id_estoque_local_destino: "", 
                com_saldo: "T", 
                sel_aplic: false, 
                tipo_aplic: "0",
                dt_aplic: this.$util.hoje(), 
                hr_aplic_ini: "",
                hr_aplic_fim: "", 
            },
            filtros_busca: null, 
            page: 1, 
            impressao_solicitacao: false, 
            retroativo: false, 
            atend_parcial: false, 
            solic_contato: null,
            lista_status: null, 
            view: 'L', 
            apenas_gaps: false, 
            detalhado: true, 
            aqss: null, 
            item_classes: [], 
            atend_por_hr_aplic: false, 
            exibir_local: false, 
            detalhe_prescr: false, 
            lista_add_filtros: [], 
            edicao_lote_qt: null, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzPeriodo, 
        SelecaoMaterial,
        CabecalhoGenerico,
        PrintExport, 
        TransformaApresentacao, 
        RegistrarContatos, 
        GerarAquisicaoLista,
        EmitirEtiqueta, 
        VerListaOcs, 
        EstoqueSolicitacaoAutorizar,
        AzAuditLogButton, 
        Formulario, 
        AzSubTitle, 
        EstoqueConsultarConsumosPacientes,
        SolicitacaoAlteracao, 
        PrescSuprimentos,
        CrmFiltros,
        MicroViewInternacao,
    },

    watch: { 
        ordem_alfa: function (nv) { 
            this.$util.setCookie('estoque-ordem-alfa', nv ? 'S' : '', 365);
        },

        exibir_local: function (nv) { 
            this.$util.setCookie('est-show-loc', nv ? 'S' : '', 365);
        }
    },

    computed: { 
        tem_localizacao: function () { 
            if ( !this.item || !this.item.items ) { 
                return false; 
            }

            return this.item.items.some(item => item.item && item.item.limite && item.item.limite.st_local) ? true : false; 
        },

        lista_horarios: function () { 
            if ( !this.lista ) { 
                return [];
            }

            return _.take(
                _.uniq(_.orderBy(this.lista.filter(item => item.hr_aplic), item => item.dt_aplic + ' ' + item.hr_aplic).map(item => item.dt_aplic + ' ' + item.hr_aplic)),
                6
            );
        },

        parms_relatorios: function () { 
            if ( !this.lista ) { 
                return {};
            }

            return { 
                solicitacao_id: this.lista.map(item => item.id_estoque_solicitacao),
            };
        },

        lista_classes: function () { 
            return _.uniq(
                this.lista_consolidada.flatMap(item => item.classes)
            ).sort();
        },

        lista_consolidada: function () { 

            /*
            if ( this.filtros.search ) { 
                let reg = this.$util.getregex(this.filtros.search);
                lista = lista.filter(item => reg.test(JSON.stringify(item)));
            }
            */

           let reg = this.$util.getregex(this.filtros.search);

            let lista = _.orderBy(
                _.map(
                    _.groupBy(
                        this.lista.filter(item => !item.fl_estorno).flatMap(item => item.items.filter(esi => esi.fl_pendente))
                            .filter(item => !this.filtros.search || reg.test(JSON.stringify(item))),
                        'id_estoque_item',
                    ),
                    items => { 
                        let novo = { 
                            id: items[0].id_estoque_item,
                            descricao: items[0].item.search, 
                            unidade: items[0].item.st_unidade_estoque, 
                            solics: items.length, 
                            lista_solics: _.uniq(items.map(esi => esi.id_estoque_solicitacao)), 
                            qtde_solic: _.sumBy(items, 'in_quantidade'), 
                            qtde_baixado: _.reduce(items.flatMap(es => es.links), (total, carry) => { 
                                return total + _.get(carry, 'movimentacao.in_quantidade', 0);
                            }, 0), 
                            saldo: _.get(items, '0.item.saldo.qtd', 0), 
                            cmm: _.get(items, '0.item.item_parm.in_cmm'), 
                            gap: 0,
                            classes: items[0].item.js_classes ? items[0].item.js_classes : [], 
                            selecao: items[0].item, 
                            selecionado: true, 
                            compra: _.get(this.aqss, items[0].id_estoque_item), 
                        };

                        novo.selecao.fl_ativo = ( !novo.compra && novo.gap > 0 ) ? true : false;

                        novo.gap = ( ( novo.qtde_solic - novo.qtde_baixado ) > novo.saldo ) 
                            ? ( novo.qtde_solic - novo.qtde_baixado ) - novo.saldo
                            : 0; 

                        if ( this.filtros.com_saldo == 'S' ) { 
                            novo.filtrar_saldo = ( novo.gap > 0 );
                        } else if ( this.filtros.com_saldo == 'N' ) { 
                            novo.filtrar_saldo = ( !novo.gap );
                        }

                        return novo;
                    }
                ),
                'descricao'
            );

            if ( this.apenas_gaps ) { 
                lista = lista.filter(item => item.gap > 0);
            }

            lista = lista.filter(item => !item.filtrar_saldo);

            // console.log('lst', lista);

            return lista;
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            let lista = this.dados.data.filter(item => !item.filtrar_saldo); 

            if ( this.filtros.search && this.view != 'C' ) { 
                let reg = this.$util.getregex(this.filtros.search);
                return lista.filter(item => !item.filtrar_saldo && reg.test(JSON.stringify(item)));
            }

            return lista;
        },

        titulo_acao: function () { 
            return ( this.item && this.item.fl_estorno ) ? 'Receber' : 'Atender';
        },

        lista_centro_custo: function () { 
            if ( !this.filtros.id_unidade_operacao )
                return [];

            let unidade = this.$store.state.unidade.unidade_operacaos
                .find(item => item.id_unidade_operacao == this.filtros.id_unidade_operacao);

            if ( unidade )
                return unidade.centro_custos;

            return [];
        }
    },

    methods: { 
        lista_lotes(material) { 
            if ( !material || !material.links )
                return;

            return _.uniq(
                    material.links.filter(link => link.movimentacao.st_lote && link.movimentacao.st_lote != 'Sem Lote')
                        .map(link => link.movimentacao.st_lote)
                ).join(', ');
        }, 
        
        atualizar_qt () { 
            if ( this.edicao_lote_qt && this.edicao_lote_qt.quantidade > 0 ) { 
                this.edicao_lote_qt.original.quantidade = parseInt(this.edicao_lote_qt.quantidade);
                this.edicao_lote_qt.material.qtde_baixa = this.edicao_lote_qt.material.lotes.reduce((acc, lote) => acc + parseInt(lote.quantidade), 0);
                this.$forceUpdate(); 
            }

            this.fechar_modal('editarQtdeModal');
        },

        editar_lote_qt (lote, material) { 
            this.edicao_lote_qt = _.cloneDeep(lote);
            this.edicao_lote_qt.original = lote; 
            this.edicao_lote_qt.material = material;

            $('#editarQtdeModal').modal('show');
        },  

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },

        incluir_filtro () { 
            this.$refs.filtros.abrir(0); 
        },

        atualizar_filtros () { 
            this.lista_add_filtros = ( this.$refs.filtros ? this.$refs.filtros.get_filtros(0) : [] ); 
        },

        selecionar_primeiro_lote () { 
            this.item.items.forEach(item => { 
                if ( item.item.fl_controla_lote 
                    && !item.st_lote 
                    && item.item 
                    && item.item.saldo_por_lote 
                    && item.item.saldo_por_lote.length ) { 

                    console.log('lotes: ', _.orderBy(
                        item.item.saldo_por_lote.filter(spl => spl.validade),
                        'validade',
                        'asc'
                    ));

                    let lote = _.first(
                        _.orderBy(
                            item.item.saldo_por_lote.filter(spl => spl.validade),
                            'validade',
                            'asc'
                        )
                    );

                    if ( lote ) { 
                        item.st_lote = lote.st_lote; 
                    }

                }
            });
        },

        refresh_aplic () { 
            this.$nextTick(() => { 
                this.load(); 
            });
        },

        selec_horario(horario) { 
            if ( horario.length > 10 ) { 
                this.filtros.dt_aplic = horario.slice(0, 10);
            }

            let hora = horario.slice(-5);

            if ( this.filtros.hr_aplic_ini == hora && this.filtros.hr_aplic_fim == hora ) { 
                this.filtros.tipo_aplic = '0'; 
                this.filtros.hr_aplic_ini = ""; 
                this.filtros.hr_aplic_fim = "";
            } else { 
                this.filtros.tipo_aplic = 'F'; 
                this.filtros.hr_aplic_ini = hora; 
                this.filtros.hr_aplic_fim = hora;
            }
            
            this.load(); 
        },

        devolver_por_solic (solic) { 
            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            let solicgeral = this.$util.get_solic_geral();
            solicgeral.solicitar('D', solic, this.load);
        },

        consultar_consumos (id_marcacao) { 
            this.$refs.consumos_pacientes.abrir(id_marcacao);
        },

        selecao_consig (item) { 
            if ( item.item && item.item.saldos_por_lote && item.item.saldos_por_lote.length ) { 
                let teste = _.uniqBy(item.item.saldos_por_lote, sl => sl.consig + '|' + sl.id_fornecedor).length; 

                if ( teste > 1 ) { 
                    return true; 
                }
            }

            return false; 
        },

        tratar_ordem (lista) { 
            if ( this.ordem_alfa ) { 
                return _.orderBy(lista, 'item.search');
            }

            return lista;
        },

        ver_aquisicao (id_aquisicao) { 
            this.$router.push({ name: 'suprimentos', params: { aba: 'aquisicao', id: id_aquisicao } });
        }, 

        gerar_aquisicao (solic) { 
            if ( !confirm('Confirma gerar processo de aquisição para a solicitação #' + solic.id_estoque_solicitacao + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'gerar_aquisicao_solicitacao', 
                dados: {
                    id_estoque_solicitacao: solic.id_estoque_solicitacao
                },
                toast: true, 
                reload: true, 
            });
        },

        autorizar_solicitacao(solic) { 
            this.$refs.aut_solic.abrir(solic.id_estoque_solicitacao);
        },

        abrir_recepcao (pesquisa) { 
            this.$router.push({ name: 'recepcao', params: { search: pesquisa } });
        }, 

        abrir_atendimento(id_atendimento) { 
            this.$util.abrir_atendimento(this, id_atendimento);
        },

        toggle_buscar_lotes(material) { 
            material.info_lote = !material.info_lote;
            this.$forceUpdate();
        },

        selecionar_nao_atender (item, index = null) { 
            if ( item.id_estoque_solicitacao_item ) { 
                item.qtde_baixa = 0; 
                item.lotes = [];
            } else if ( index !== null ) { 
                this.item.items.splice(index, 1);
            }
        },

        ver_ocs (item) { 
            this.$refs.ver_ocs.abrir(item);
        }, 
        
        selecionar_classe (classe) { 
            if ( this.filtros.classe == classe ) { 
                this.filtros.classe = "";
            } else { 
                this.filtros.classe = classe;
            }

            this.$nextTick(() => { 
                this.load();
            });
        },  

        cancelar_solicitacao (solic) { 
            if ( !confirm('Confirma cancelar a solicitação #' + solic.id_estoque_solicitacao + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'cancelar_solicitacao', 
                dados: {
                    id_estoque_solicitacao: solic.id_estoque_solicitacao
                },
                toast: true, 
                reload: true, 
            });
        },

        printEtiqueta (marcacao) {
          this.$refs.etiqueta.emitir('marcacao', marcacao);
        },

        incluir_aquisicao () { 
            console.log('ia', this.lista_consolidada);

            let lista = this.lista_consolidada.filter(item => item.selecionado) // item.selecao.fl_ativo)
                .map(item => { 
                    return { 
                        qtde_compra: item.gap,
                        ...item.selecao, 
                    }
                });

            console.log('la', lista);

            if ( !lista.length ) { 
                this.$toast.add({ 
                    severity: "error",
                    summary: "Gerar Processo Aquisição",
                    detail: "Nenhum item selecionado.",
                    life: 3000    
                });
                return;
            }

            this.$refs.gerar_aq.incluir_aquisicao(
                lista, 
                { 
                    id_estoque_local: this.filtros.id_estoque_local 
                }
            );
        },

        filtrar (texto) { 
            if ( this.filtros.search == '"' + texto + '"' ) { 
                this.filtros.search = ""; 
            } else { 
                this.filtros.search = '"' + texto + '"';
            }   
        },

        registrar_contatos (solic) { 
            if ( this.lista_status === null ) { 

                this.$util.loadItem(this, { 
                    service: 'contato_status', 
                    func: 'index',
                    parms: { 
                        model: 'estoqueSolicitacao', 
                        ativos: true, 
                    },
                })
                .then(res => { 
                    this.lista_status = res;
                });

            }

            this.solic_contato = _.cloneDeep(solic);

            this.solic_contato.nome_paciente = '#' + this.solic_contato.id_estoque_solicitacao;
            
            this.solic_contato.model = { 
                type: 'estoqueSolicitacao',
                id: this.solic_contato.id_estoque_solicitacao, 
            };

            this.$refs.regcontatos.editar(this.solic_contato);
        },

        substituto (esi, sub) { 
            //esi.id_estoque_item = sub.por.id_estoque_item;
            //esi.item = sub.por;

            if ( esi.links && esi.links.length ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Substituto",
                    detail: "Item com movimentação registrada.",
                    life: 3000    
                })
                return; 
            }

            this.$util.loadItem(this, { 
                service: "estoque_items",
                id: sub.por.id_estoque_item, 
                parms: { 
                    saldos: true, 
                    id_estoque_local: this.item.id_estoque_local,
                    lotes: true, 
                    num_lote: "", 
                    reservas: true, 
                    componentes: true, 
                    subs: true, 
                }
            })
            .then(res => { 
                esi.id_estoque_item = res.id_estoque_item;
                esi.item = res;
                esi.st_lote = "";
                esi.tem_sub = true;

                /*
                if ( !res.saldo ) { 
                    novoitem.saldo = { 
                        qtd: 0, 
                    };
                    novoitem.reservado = 0;
                } else { 
                    novoitem.saldo = res.saldo;
                    novoitem.reservado = res.reservado ? res.reservado : 0;
                }
                */
            });
        },

        ver_subs (esi) { 
            esi.list_subs = !esi.list_subs;
            this.$forceUpdate();
        },

        reabrir (id_estoque_solicitacao) { 
            let solic = this.lista.find(item => item.id_estoque_solicitacao == id_estoque_solicitacao);

            if ( solic ) { 
                this.iniciar_atender(solic);
            }
        },

        transformar (item) { 
            $('.modal').modal("hide");

            this.$refs.transform.abrir({ 
                id_estoque_local: this.item.id_estoque_local,
                item: item, 
            });
        },

        imprimir_solicitacao (solic) { 
            this.$util.print_preview('imprimir/solicitacao/' + solic.id_estoque_solicitacao, true);
        },

        buscar_lotes (item) { 
            if ( item.exibir_lotes ) { 
                item.exibir_lotes = false;
            } else { 
                item.exibir_lotes = true;    
            }
            this.$forceUpdate();
        },

        qtde_lote(material) { 
            if ( !material || !material.item || !material.item.saldo_por_lote ) { 
                return '?';
            }

            return material.item.saldo_por_lote.reduce((total, carry) => { 
                return total + ( ( !material.st_lote || ( carry.st_lote && material.st_lote.toUpperCase() == carry.st_lote.toUpperCase() ) ) ? carry.qtd : 0 );
            }, 0);
        },

        adicionar_lote (material) { 
            let novo = _.cloneDeep(material);

            novo.in_quantidade = material.in_quantidade - material.qtde_baixa;
            novo.st_lote = "";

            material.outro_lote = true;
            
            this.item.items.push(novo);    
        },

        identificar_item(info) { 

            if ( !info )  
                return;

            let qtde_ident = ( info.quantidade ? parseInt(info.quantidade) : 1 );

            console.log('info', info); 
            
            if ( info.fl_controla_lote ) { 

                if ( !_.get(info, 'lote.numero') ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Identificação",
                        detail: "Necessário informar o lote para esse material.",
                        life: 3000
                    });
                    return;
                }

                let localizado = this.item.items.find(esi => esi.id_estoque_item == info.id_estoque_item
                    && ( esi.st_lote == _.get(info, 'lote.numero') || !esi.st_lote ) 
                    && ( esi.in_quantidade >= esi.qtde_baixa + qtde_ident));
                    
                if ( !localizado ) { 

                    if ( this.item.items.find(esi => esi.id_estoque_item == info.id_estoque_item) ) { 

                        this.$toast.add({
                            severity: "warn",
                            summary: "Identificação",
                            detail: "Item não identificado: " + info.search + " (" + _.get(info, 'lote.numero') + ")",
                            life: 3000
                        });

                    } else { 

                        if ( !confirm('Item não identificado. Deseja incluir?') ) { 
                            return;
                        }

                        this.$util.loadItem(this, { 
                            service: "estoque_items",
                            id: info.id_estoque_item, 
                            parms: { 
                                saldos: true, 
                                id_estoque_local: this.item.id_estoque_local,
                                lotes: true, 
                                num_lote: _.get(info, 'lote.numero'), 
                                reservas: true, 
                                componentes: true, 
                                subs: true, 
                            }
                        })
                        .then(res => { 
                            this.item.items.push({ 
                                id_estoque_solicitacao_item: "", 
                                id_estoque_item: res.id_estoque_item,
                                item: _.cloneDeep(res),
                                in_quantidade: qtde_ident,
                                qtde_baixa: qtde_ident,
                                st_lote: _.get(info, 'lote.numero'), 
                                tem_sub: true,
                                fl_ativo: true, 
                                fl_pendente: false, 
                            });
                        });

                    }

                    return;
                }

                if ( !localizado.st_lote ) { 
                    if ( !localizado.lotes ) { 
                        localizado.lotes = [];
                    }

                    localizado.lotes.push(_.cloneDeep(info));
                }

                localizado.qtde_baixa = localizado.qtde_baixa + qtde_ident;

            } else { 

                let localizado = this.item.items.find(esi => esi.id_estoque_item == info.id_estoque_item
                    && esi.in_quantidade >= esi.qtde_baixa + qtde_ident);

                if ( !localizado ) { 

                    if ( 1==0 && this.item.items.find(esi => esi.id_estoque_item == info.id_estoque_item) ) { 

                        this.$toast.add({
                            severity: "warn",
                            summary: "Identificação",
                            detail: "Item não identificado: " + info.search,
                            life: 3000
                        });

                    } else { 

                        if ( !confirm('Item não identificado. Deseja incluir?') ) { 
                            return;
                        }

                        this.$util.loadItem(this, { 
                            service: "estoque_items",
                            id: info.id_estoque_item, 
                            parms: { 
                                saldos: true, 
                                id_estoque_local: this.item.id_estoque_local,
                                lotes: true, 
                                num_lote: "", 
                                reservas: true, 
                                componentes: true, 
                                subs: true, 
                            }
                        })
                        .then(res => { 
                            this.item.items.push({ 
                                id_estoque_solicitacao_item: "", 
                                id_estoque_item: res.id_estoque_item,
                                item: _.cloneDeep(res),
                                in_quantidade: qtde_ident,
                                qtde_baixa: qtde_ident,
                                st_lote: "", 
                                tem_sub: true,
                                fl_ativo: true, 
                                fl_pendente: false, 
                            });
                        });

                    }

                    return;

                }

                localizado.qtde_baixa = localizado.qtde_baixa + qtde_ident;

            }
        },

        incluir () { 
            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            let solicgeral = this.$util.get_solic_geral();
            solicgeral.solicitar(null, null, this.load);
        },

        devolver () { 
            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            let solicgeral = this.$util.get_solic_geral();
            solicgeral.solicitar('D', null, this.load);

            // this.$refs.solic.solicitar('D');
        },

        transferir () { 
            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            let solicgeral = this.$util.get_solic_geral();
            solicgeral.solicitar('T', null, this.load);

            //this.$refs.solic.solicitar('T');
        },

        paginar(page) { 
            this.page = page;
            this.load();
        },

        atender() { 
            this.$util.setCookie('solic-impresso', this.impressao_solicitacao ? 'S' : 'N');

            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'atender',
                dados: { 
                    solic: this.item,
                },
                modal: 'estoqueAtenderModal',
                toast: true,
                reload: true,
                callback: () => { 
                    if ( this.impressao_solicitacao ) { 
                        this.imprimir_solicitacao(this.item);
                    }
                }
            });
        },

        cor_linha (item) { 
            if ( item.fin ) 
                return 'secondary';

            if ( item.qtde_baixa == ( item.in_quantidade - ( item.baixado ? item.baixado : 0 ) ) )
                return 'success';

            if ( item.qtde_baixa && item.qtde_baixa < ( item.in_quantidade - ( item.baixado ? item.baixado : 0 ) ) )
                return 'warning';

            if ( item.qtde_baixa === 0 )
                return 'danger';

            return;
        },

        indicar_atendimento (solic, atender = true) { 
            solic.items.forEach(item => {
                if ( !item.fin ) { 
                    item.qtde_baixa = atender ? ( item.in_quantidade - ( item.baixado ? item.baixado : 0 ) ) : 0;
                    item.fl_pendente = false;
                }
            });
        },

        iniciar_atender (solic) { 
            this.impressao_solicitacao = ( this.$util.getCookie('solic-impresso') == 'S' );

            this.item = _.cloneDeep(solic);
            this.item.carregando = true;

            this.$util.load(this, { 
                service: 'estoque_solicitacoes',
                func: 'show',
                parms: { 
                    atendimento: true, 
                    saldo_lotes: true, 
                    id: solic.id_estoque_solicitacao,
                    id_estoque_local: this.item.id_estoque_local, 
                    id_paciente: ( this.item.fl_estorno && this.item.marcacao ) ? this.item.marcacao.id_paciente : null, 
                },
                loadTo: res => { 
                    res.retroativo = false;
                    res.dt_retroativo = "";

                    this.retroativo = this.$store.state.contexto['estoq-mov-retroativo'] == 1;
                    this.atend_parcial = this.$store.state.contexto['estoq-atend-parcial'] == 1;

                    this.item = res;
                },
                configs: [
                    'estoq-mov-retroativo', 
                    'estoq-atend-parcial', 
                ]
            });

            this.$nextTick(() => { 
                $('#estoqueAtenderModal').modal('show');
            })
        },

        load(limpar = false) { 
            if ( limpar ) { 
                this.dados = null;
                this.aqss = null; 
            }

            if ( this.montando )
                return;

            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            if ( !this.filtros.id_estoque_local ) { 
                this.filtros.com_saldo = 'T';
            }

            this.filtros_busca = _.cloneDeep(this.filtros);

            this.$util.load(this, { 
                service: 'estoque_solicitacoes',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: { 
                    atendimento: true, 
                    ...this.filtros,
                    add_filtros: this.lista_add_filtros, 
                    size: 100,
                    page: this.page,
                    saldos: ( this.filtros_busca.id_estoque_local && ( this.view == 'C' || this.filtros.com_saldo != 'T' ) ) ? true : false, 
                    atend_consolid: this.view == 'C' ? true : false, 
                },
                loadTo: res => { 
                    this.dados = res;
                    this.aqss = _.get(res, 'data.0.aqss');
                }
            });
        },
    },

    beforeMount() {
        this.filtros.id_estoque_local = this.$util.getCookie('estoque-armazem');
        this.ordem_alfa = ( this.$util.getCookie('estoque-ordem-alfa') == 'S' );
        this.exibir_local = ( this.$util.getCookie('est-show-loc') == 'S' );
    },

    mounted () { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Atendimento", path: "/suprimentos/atendimento" }
        ]);

        if ( this.$route.params && this.$route.params.search ) { 
            this.filtros.search = this.$route.params.search;
        }

        this.montando = false;

        this.$nextTick(() => { 
            this.load();
        });

        this.$util.loadItem(this, { 
            service: 'estoque_items',
            func: 'tags',
            configs: ['estoque-solic-atender-por-horario'],
        })
        .then(res => { 
            this.item_classes = res.map(item => { 
                return { 
                    id: item,
                    search: item,
                };
            });

            this.atend_por_hr_aplic = !!this.$store.state.contexto['estoque-solic-atender-por-horario'];
        });
    },

    updated () { 
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    }
    
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>